import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import { BuddyListModel, BuddyRequestModel } from "@modules/study-buddy/types.ts";

export default {
  fetchPendingAcceptanceCount(): Promise<ApiResponse<number>> {
    return httpClient.get(`/apis/buddy/pending-count`);
  },
  fetchStudyBuddyListing(): Promise<ApiResponse<BuddyListModel[]>> {
    return httpClient.get(`/apis/buddy/get`);
  },
  removeStudyBuddyMultiple(uuids: []): Promise<ApiResponse<void>> {
    const params = new URLSearchParams();
    params.append("buddyUserIds", uuids.toString());
    return httpClient.post(`/apis/buddy/remove-all`, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
  sendStudyBuddyRequest(buddyUserId: number): Promise<ApiResponse<void>> {
    const params = new URLSearchParams();
    params.append("buddyUserId", buddyUserId.toString());
    return httpClient.post(`/apis/buddy/request/send`, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
  fetchPendingAcceptanceBuddyRequests(): Promise<ApiResponse<BuddyListModel[]>> {
    return httpClient.get(`/apis/buddy/pending-acceptance`);
  },
  fetchAllPendingBuddyRequests(): Promise<ApiResponse<BuddyRequestModel[]>> {
    return httpClient.get(`/apis/buddy/pending`);
  },
  acceptPendingAcceptanceBuddyRequests(ids: string[]): Promise<ApiResponse<void>> {
    const params = new URLSearchParams();
    params.append("buddyUserIds", ids.toString());
    return httpClient.post(`/apis/buddy/request/accept`, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
  rejectPendingAcceptanceBuddyRequests(ids: string[]): Promise<ApiResponse<void>> {
    const params = new URLSearchParams();
    params.append("buddyUserIds", ids.toString());
    return httpClient.post(`/apis/buddy/request/reject`, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
};
